import { useContext } from 'react'

import JourneyWhiteLabelContext from 'contexts/JourneyWhiteLabelContext'

const useJourneyWhiteLabel = () => {
  const context = useContext(JourneyWhiteLabelContext)

  if (!context) {
    throw new Error(
      'useJourneyWhiteLabel must be used within a JourneyWhiteLabelProvider',
    )
  }

  return context
}

export default useJourneyWhiteLabel
